import { render, staticRenderFns } from "./jobCard.vue?vue&type=template&id=0bd8cfd2&scoped=true"
import script from "./jobCard.vue?vue&type=script&lang=js"
export * from "./jobCard.vue?vue&type=script&lang=js"
import style0 from "./jobCard.vue?vue&type=style&index=0&id=0bd8cfd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd8cfd2",
  null
  
)

export default component.exports